import { Injectable } from '@angular/core';
import { JobDataServiceBase } from 'scaletech-jobs';
import { HttpClient } from '@angular/common/http';
import { WebApiService } from 'starbase-login';

@Injectable({
  providedIn: 'root'
})
export class JobDataService extends JobDataServiceBase {

  constructor(http: HttpClient, webApi: WebApiService) {
    super(http, webApi);
  }
}
